module.exports = __webpack_public_path__ + "img/A6.28b6a616.png";